import useRedirectIfPreviousComponentsAreNotSelected from "common/useRedirectIfPreviousComponentsAreNotSelected"
import styled from "styled-components"
import ShowStockToggle from "../wizard/ShowStockToggle"
import DetailingButtons from "./DetailingButtons"
import SelectedDetailingDetails from "./SelectedDetailingDetails"

const StyledDetailingButtonsContainer = styled.div`
  ${(p) => p.theme.breakpoints.up("md")} {
    text-align: right;
  }
`

const DetailingSidebar = () => {
  useRedirectIfPreviousComponentsAreNotSelected()

  return (
    <>
      <StyledDetailingButtonsContainer>
        <ShowStockToggle />
        <DetailingButtons />
      </StyledDetailingButtonsContainer>
      <SelectedDetailingDetails hasBackground />
    </>
  )
}

export default DetailingSidebar
